<div class="fs-20" *scRichText="rendering.fields.text"></div>
<div class="text-center mt-4">
  <button
    class="btn btn-primary"
    (click)="goToPrevious()"
    *scText="rendering.fields.previousButtonLabel"
  ></button>
  <ng-container *ngIf="home">
    <ng-container *ngIf="home.value.href; else elseBlock">
      <a ngClass="btn btn-primary" *scLink="home"></a>
    </ng-container>
    <ng-template #elseBlock>
      <a ngClass="btn btn-primary" href="/">{{home.value.text}}</a>
    </ng-template>
</ng-container>
</div>
